module.exports = __webpack_public_path__ + "img/legend.3cdfe705.png";